module.exports = __webpack_public_path__ + "img/q-banner.305e8a79.png";